import React, { useEffect, useState } from 'react'
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Support from "../contact-popup-module/Support";
const ExpiredStatus = () => {
  const link_status = `${process.env.PUBLIC_URL}/custom-icons/link_status.png`;
  const link = `${process.env.PUBLIC_URL}/custom-icons/link.png`;
  const [imgWidth, setImgWidth] = useState("50%");
  const [imgHeight, setImgHeight] = useState("auto");

  const [divWidth, setDivWidth] = useState("35%")


  useEffect(() => {
    const handleResize = () => {
      const windowWidth = window.innerWidth;
      if (windowWidth <= 410) {
        setImgWidth("98%");
        setDivWidth("92%")
      }
      else if (windowWidth <= 475) {
        setImgWidth("100%");
        setDivWidth("92%")
      } else if (windowWidth <= 575) {
        setImgWidth("62%");
        setDivWidth("90%")
      } else if (windowWidth <= 650) {
        setImgWidth("60%");
        setDivWidth("85%")
      } else if (window.innerWidth <= 775) {
        setImgWidth("56%");
        setDivWidth("65%")
      } else if (window.innerWidth <= 875) {
        setImgWidth("52%");
        setDivWidth("55%")
      } else if (windowWidth <= 1000) {
        setImgWidth("52%");
        setDivWidth("40%")
      } else if (window.innerWidth <= 1100) {
        setImgWidth("52%");
        setDivWidth("40%")
      } else if (windowWidth <= 1300) {
        setImgWidth("52%");
        setDivWidth("35%")
      } else {
        setImgWidth("50%");
        setDivWidth("35%")
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();
    // Cleanup function to remove event listener
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (

    <div
      style={{
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        height: "100svh",
        gap: "1rem",
        marginBottom: "0.5rem",
      }}
    >
      <img
        src={link_status}
        style={{
          width: imgWidth,
          height: imgHeight,
          maxHeight: "70svh",
          objectFit: "contain",
        }}
        alt="Link Status"
      />
      <div
        style={{
          padding: "1.5rem 1.3rem 0rem 1.3rem",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
          borderRadius: "3px",
          width: divWidth,
          height: "185px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "0.3rem",
          flexDirection: "column",
          position: "absolute",
          bottom: "0.3rem",
          marginBottom: "1rem"
        }}
      >
        <p
          style={{
            fontWeight: "600",
            fontSize: "1.7rem",
            fontFamily: "Barlow Condensed",
            marginBottom: "0.5rem"
          }}
        >
          Link has expired
        </p>
        <p style={{ fontFamily: "'Montserrat', sans-serif", lineHeight: "20px", fontSize: "0.9rem", color: "grey" }}>
          The provided audit link has expired. Please contact support if you require further assistance
        </p>
        <button
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "0.2rem",
            border: "1.5px solid #FC350B",
            padding: "0rem 1rem",
            backgroundColor: "white",
            borderRadius: "3px",
            opacity: "0.9",
            width: "100%"
          }}
          onClick={handleClickOpen}
        >
          <p
            style={{
              fontSize: "0.9rem",
              fontFamily: "'Montserrat', sans-serif",
              color: "#FC350B",
              padding: "0.5rem",
              cursor: "pointer"
            }}

          >
            Contact
          </p>
        </button>
        {/* Support Popup */}
        <Dialog open={open} onClose={handleClose} className="support-popup-dialog">
          <DialogContent className="support-popup-content">
            <Support />
            <button onClick={handleClose} className="close-btn">close</button>
          </DialogContent>
        </Dialog>
      </div>
    </div>
  );
}

export default ExpiredStatus